<div class="cardLayout">
  <ion-row>
    <ion-col size="4">
      <div class="formLabelBoldfs18 mb-5 fs_16ForMobile">{{popupName}}</div>
    </ion-col>
    <ion-col size="8" class="text-right">
      <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png" />
    </ion-col>
  </ion-row>
  <mat-dialog-content>
    <ion-row>
      <ion-col size="12">
        <div class="item-data mb-15">
          <div class="item-labels formLabelBoldfs16 mb-5">Created Details</div>
          <div class="item-values phi-flex-wrap-center phi-gap-12">
            <div>
              <span class="formLabelBoldfs14">
                Date:
                <span class="formLabelRegularfs14">{{ createdAt | date: 'dd-MM-yyyy' }}</span>
              </span>
            </div>
            <div>
              <span class="formLabelBoldfs14">
                Time:
                <span class="formLabelRegularfs14">{{ createdAt | date: 'HH:mm' }}</span>
              </span>
            </div>
            <!-- <div>
              <span class="formLabelBoldfs14">
                By:
                <span class="formLabelRegularfs14">{{ createdBy }}</span>
              </span>
            </div> -->
          </div>
        </div>
      </ion-col>

      <ion-col size="12">
        <div class="item-data mb-15">
          <div class="item-labels formLabelBoldfs16 mb-5">Updated Details</div>
          <div class="item-values phi-flex-wrap-center phi-gap-12">
            <div>
              <span class="formLabelBoldfs14">
                Date:
                <span class="formLabelRegularfs14">{{ updatedAt | date: 'dd-MM-yyyy' }}</span>
              </span>
            </div>
            <div>
              <span class="formLabelBoldfs14">
                Time:
                <span class="formLabelRegularfs14">{{ updatedAt | date: 'HH:mm' }}</span>
              </span>
            </div>
            <!-- <div>
              <span class="formLabelBoldfs14">
                By:
                <span class="formLabelRegularfs14">{{ updatedBy }}</span>
              </span>
            </div> -->
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="popupName == 'Modules List'" class="modules-list">
      <ion-col size="12" *ngFor="let item of listData">
        <span class="formLabelRegularfs16">{{item.moduleName}}</span>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="popupName == 'Access'">
      <ion-col size="12">
        <div class="item-data mb-15">
          <div class="item-labels formLabelBoldfs16 mb-5">Location</div>
          <div class="item-values formLabelRegularfs14">
            <label *ngFor="let item of locationList; let isLast=last">{{item}}{{isLast ? '' : ',&nbsp;'}}</label>
          </div>
        </div>
      </ion-col>
      <ion-col size="12">
        <div class="item-data mb-15">
          <div class="item-labels formLabelBoldfs16 mb-5">Band</div>
          <div class="item-values formLabelRegularfs14">
            <label *ngFor="let item of bandList; let isLast=last">{{item}}{{isLast ? '' : ',&nbsp;'}}</label>
          </div>
        </div>
      </ion-col>
      <ion-col size="12">
        <div class="item-data mb-15">
          <div class="item-labels formLabelBoldfs16 mb-5">Department</div>
          <div class="item-values formLabelRegularfs14">
            <label *ngFor="let item of departmentList; let isLast=last">{{item}}{{isLast ? '' : ',&nbsp;'}}</label>
          </div>
        </div>
      </ion-col>
      <ion-col size="12">
        <div class="item-data mb-15">
          <div class="item-labels formLabelBoldfs16 mb-5">Designation</div>
          <div class="item-values formLabelRegularfs14">
            <label *ngFor="let item of designationList; let isLast=last">{{item}}{{isLast ? '' : ',&nbsp;'}}</label>
          </div>
        </div>
      </ion-col>
      <ion-col size="12">
        <div>
          <div class="item-data mb-15" class="item-labels formLabelBoldfs16 mb-5">Employee</div>
          <div class="item-values formLabelRegularfs14">
            <label *ngFor="let item of employeeList; let isLast=last">{{item.firstName}} {{item.lastName}}{{isLast ? '' : ',&nbsp;'}}</label>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </mat-dialog-content>
</div>
